import { ellipsis } from "@/common/style/commonStyle";
import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	fieldsContainer: {
		width: "65%",
	},
	highlightedInputField: {
		backgroundColor: tokens.colorBrandBackgroundInvertedSelected
	},
	extraFieldsButton: {
		paddingLeft: 0,
		marginLeft: "-8px",
	},
	groupedFieldsValidationMessage: {
		fontSize: tokens.fontSizeBase200,
		color: tokens.colorPaletteRedForeground1,
	},
	queuesValidationMessage: {
		fontSize: tokens.fontSizeBase200,
		color: tokens.colorPaletteRedForeground1,
		marginTop: "10px",
	},
	multiCheckbox: {
		overflowY: "auto",
	},
	multiCheckboxWhenFormExpanded: {
		maxHeight: "350px",
	},
	multiCheckboxWhenFormCollapsed: {
		maxHeight: "120px",
	},
	multiCheckboxItem: {
		"&>label": {
			...ellipsis(),
		},
	},
	queueListContainer: {
		width: "30%",
	},
	queuesLabel: {
		lineHeight: "24px",
	},
	queuesDivider: {
		marginBottom: "4px",
	},
	buttonsContainer: {
		marginTop: "16px",
	},
});
